import Navbar from '../layout/Navbar/Navbar'
import Hero from '../layout/Hero/Hero'
import Info from '../layout/Info/Info'
import Browsers from '../layout/Browsers/Browsers'
import FAQ from '../layout/FAQ/FAQ'
import Users from '../layout/Users/Users'
import Download from '../layout/Download/Download'
import Newsletter from '../layout/Newsletter/Newsletter'
import Footer from '../layout/Footer/Footer'

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Info />
      <Browsers />
      <FAQ />
      <Users />
      <Download />
      <Newsletter />
      <Footer />
    </>
  )
}
